import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './Routes';
import './App.scss';

function App() {
  return (
    <Container fluid className="d-flex flex-column min-vh-100 mx-0 px-0 py-0">
        <Router>
          <AppRoutes />
        </Router>
    </Container>
  );
}

export default App;
